<microsec-form-builder #fb [fields]="fields" [shouldShowActionButtons]="true" [submitButtonLabel]="''" [cancelButtonLabel]="OK_LABEL" />
